// extracted by mini-css-extract-plugin
module.exports = {"ImgSectionPro":"ImgSectionPro_ImgSectionPro__s62cH"};